import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_babe_39a4e7992ab4a0174bf7da6fa6c56d96/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTopButton"] */ "/app/src/app/components/back-to-top-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/badge/badge-factory.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NumberedBadge"] */ "/app/src/app/components/badge/layouts/numbered/numbered-badge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/badge/layouts/text/text-badge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/error-boundary/error-boundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game-badge-image/game-badge-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameFactoryClient"] */ "/app/src/app/components/game/game-factory.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExclusivePostLaunch"] */ "/app/src/app/components/game/layouts/exclusive-post-launch/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/animated-tile/animated-tile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotAmountAndTime"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-amount-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JackpotDescription"] */ "/app/src/app/components/game/subcomponents/daily-jackpot/daily-jackpot-description.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/details/game-details.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/game-url/game-url.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/info-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/game/subcomponents/swj-border-overlay/swj-border-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GenerositySwimlane"] */ "/app/src/app/components/generosity-swimlane/generosity-swimlane.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfluencerVideoLibraryExposureEffects"] */ "/app/src/app/components/influencer-video-library-exposure-effects/influencer-video-library-exposure-effects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RewardMachineBanner"] */ "/app/src/app/components/reward-machine/reward-machine-banner/reward-machine-banner.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/reward-machine/reward-machine-banner/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/rich-text/rich-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteWideJackpotZone"] */ "/app/src/app/components/site-wide-jackpot/lobby-zone/lobby-zone.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/site-wide-jackpot/subcomponents/jackpot-ticker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WelcomeLobbyMessage"] */ "/app/src/app/components/user-profile/welcome-lobby-message.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicOrderingProvider"] */ "/app/src/app/components/zones/contexts/dynamic-ordering-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/contexts/zone-layout-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllNewGamesZone"] */ "/app/src/app/components/zones/layouts/all-new-games/all-new-games-zone.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselZoneClient"] */ "/app/src/app/components/zones/layouts/carousel/carousel-zone.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/carousel/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/category-header-zone/styles/fanduel.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CollectionZoneClient"] */ "/app/src/app/components/zones/layouts/collection/collection-zone-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/collection/styles/default.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CollectionsEntryShowcaseTile"] */ "/app/src/app/components/zones/layouts/collections-entry-showcase/collections-entry-showcase-tile.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/collections-entry-showcase/styles/default.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ExclusivePreLaunchZone"] */ "/app/src/app/components/zones/layouts/exclusive-pre-launch/exclusive-pre-launch-zone.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfluencerGameplaySessionsCarousel"] */ "/app/src/app/components/zones/layouts/influencer-gameplay-sessions/influencer-gameplay-sessions-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/influencer-gameplay-sessions/styles/fanduel.scss");
;
import(/* webpackMode: "eager", webpackExports: ["InfluencerVideoTile"] */ "/app/src/app/components/zones/layouts/influencer-gameplay-sessions/subcomponents/influencer-video-tile/influencer-video-tile.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/influencer-page-entry-point/styles/default.scss");
;
import(/* webpackMode: "eager", webpackExports: ["InfluencerPageEntryPointTile"] */ "/app/src/app/components/zones/layouts/influencer-page-entry-point/subcomponents/influencer-tile/influencer-page-entry-point-tile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewToYouZone"] */ "/app/src/app/components/zones/layouts/new-to-you/new-to-you-zone.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/post-launch/styles/default.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyPlayedZone"] */ "/app/src/app/components/zones/layouts/recently-played/recently-played.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/rich-text-zone/styles/fanduel.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SimilarGamesZone"] */ "/app/src/app/components/zones/layouts/similar-games/similar-games-zone.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkinnyBannerLink"] */ "/app/src/app/components/zones/layouts/skinny-banner/skinny-banner-link.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiZoneClient"] */ "/app/src/app/components/zones/multi-zone/multi-zone.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RotatingZoneTitle"] */ "/app/src/app/components/zones/subcomponents/zone-header/rotating-zone-title.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/subcomponents/zone-header/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/influencer-gameplay-sessions/subcomponents/influencer-game-tile/styles/default.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/layouts/skinny-banner/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/zones/multi-zone/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/seo-description/styles/fanduel.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/elements/category-view-all/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/elements/draggable-wrapper/draggable-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoritesButton"] */ "/app/src/app/elements/favorites-button/favorites-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoProvider"] */ "/app/src/app/elements/video/video-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/elements/video/video.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
